import { DEFAULT_DATE_TIME_RANGE } from '@modules/common/components/DateRangePicker/constants';
import {
  DEFAULT_ANOMALY_THRESHOLD,
  DEFAULT_QUANTIFY_SORT_BY,
  DEFAULT_QUANTIFY_TOP_SELECTION_VALUE,
} from '@modules/quantify/constants';
import { EqlQueryType, TimeUnit } from 'generated/graphql';

import { QuantifyVisualisationType } from 'generated/graphql';
import { QuantifyState } from './types';

export const quantifyInitialState: QuantifyState = {
  query: {
    duration: DEFAULT_DATE_TIME_RANGE,
    type: EqlQueryType.Aggregates,
    compareQuery: undefined,
    formulaQuery: undefined,
    shouldShowAnomalies: false,
    anomalyThreshold: DEFAULT_ANOMALY_THRESHOLD,
    sortBy: DEFAULT_QUANTIFY_SORT_BY,
    aggregatePeriod: TimeUnit.Month,
    isCoOccurring: false,
    visibleDataPoints: [],
    shouldShowTopDataPoints: true,
    topDataPointsSelectionCount: DEFAULT_QUANTIFY_TOP_SELECTION_VALUE,
    visualisationType: QuantifyVisualisationType.Bar,
  },
  visual: {
    shouldShowCategories: false,
    shouldShowAllValues: true,
    hasQueryChanged: false,
    isEditMode: true,
    isTableQueryInProgress: false,
    isChartQueryInProgress: false,
    isCustomAnomalyThresholdSelected: false,
    pageNumber: 1,
    timeRangeTraversal: {
      originalDuration: DEFAULT_DATE_TIME_RANGE,
      traverseCount: 0,
    },
    totalAggregateHits: Number.MAX_SAFE_INTEGER,
    searchTerm: '',
    tableAggregateHits: Number.MAX_SAFE_INTEGER,
    shouldHighlightWhereClauseField: false,
    shouldHighlightDurationField: false,
    dashboardFilters: null,
    quantifyAndDashboardFilters: {
      whereClause: null,
      denominatorWhereClause: null,
      compareQuery: undefined,
    },
  },
  reportData: {
    quantify: {
      tableRows: null,
      chartDataPoints: null,
      aggregateFormulaResponse: null,
      valueRange: null,
    },
    compare: {
      tableRows: null,
      chartDataPoints: null,
      aggregateFormulaResponse: null,
      valueRange: null,
    },
  },
  misc: {
    compareQBFieldA: null,
    compareQBFieldB: null,
  },
};
